import {
	Avatar,
	Box,
	Button,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
	useDisclosure,
	useToast,
} from "@chakra-ui/react";
import PageSectionTitle from "../components/PageSectionTitle";
import { useConnectedUser } from "../hooks/user.hooks";
import PrimaryButton from "../components/PrimaryButton";
import { resetPassword } from "../mutations/auth.mutations";
import { useMutation } from "react-query";
import { useCallback } from "react";
import i18n from "../i18n";
import UserMeForm from "../components/forms/UserMeForm";
import { useCenters } from "../hooks/centers.hooks";
import { fPhoneNumber } from "../lib/format";

function SettingsPagePersonnalInformationPanel() {
	const user = useConnectedUser();
	const { center } = useCenters();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const toast = useToast();
	const { mutate: mutateResetPassword } = useMutation(resetPassword);

	const handleResetPassword = useCallback(() => {
		if (user) {
			mutateResetPassword({ email: user.email });
			toast({
				title: "Changement de mot de passe",
				description: "Vérifiez vos mails",
				status: "success",
				duration: 5000,
				isClosable: true,
			});
		}
	}, [user, mutateResetPassword, toast]);

	if (!user) {
		return <></>;
	}
	return (
		<>
			<Flex justifyContent={"space-between"}>
				<PageSectionTitle>Informations personnelles</PageSectionTitle>
				<PrimaryButton w="10rem" onClick={onOpen}>
					Modifier
				</PrimaryButton>
			</Flex>

			{/* Update modal */}
			<Modal isOpen={isOpen} onClose={onClose} isCentered size={"xl"}>
				<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
				<ModalContent>
					<ModalHeader>Modifier vos informations personnelles</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<UserMeForm user={user} onSuccess={onClose}></UserMeForm>
					</ModalBody>
					<ModalFooter>
						<Flex w="100%" justifyContent={"space-between"}>
							<Button
								variant="link"
								color="brand.700"
								onClick={handleResetPassword}
							>
								Changer de mot de passe
							</Button>
							<Button variant="outlined" color="brand.700" onClick={onClose}>
								Fermer
							</Button>
						</Flex>
					</ModalFooter>
				</ModalContent>
			</Modal>

			<Flex mt="44px">
				<Avatar
					name={`${user.firstName} ${user.lastName}`}
					src="https://bit.ly/cbouchard"
					h="40px"
					w="40px"
					mr="10px"
				/>
				<Flex direction="column">
					<Text
						lineHeight="21px"
						fontWeight="600"
						size="14px"
						textTransform="capitalize"
					>
						{user.firstName} {user.lastName}
					</Text>
					<Text lineHeight="21px" color="gray.500" textTransform="capitalize">
						{user.isSuperAdmin ? "Supembouts" : i18n.t(user.role)}
					</Text>
				</Flex>
			</Flex>

			<Box mt="1rem" w="80%" fontSize={"16px"}>
				<Flex
					my="12px"
					mx="4px"
					py="12px"
					borderBottom="1px"
					borderColor="gray.100"
					justifyContent={"space-between"}
					_hover={{ bg: "zinc.50" }}
				>
					<Text>Nom</Text>
					<Text>
						{user.firstName} {user.lastName}
					</Text>
				</Flex>
				<Flex
					my="12px"
					mx="4px"
					py="12px"
					borderBottom="1px"
					borderColor="gray.100"
					justifyContent={"space-between"}
					_hover={{ bg: "zinc.50" }}
				>
					<Text>Téléphone</Text>
					<Text>{fPhoneNumber(user.phoneNumber ?? "")}</Text>
				</Flex>
				<Flex
					my="12px"
					mx="4px"
					py="12px"
					borderBottom="1px"
					borderColor="gray.100"
					justifyContent={"space-between"}
					_hover={{ bg: "zinc.50" }}
				>
					<Text>Role</Text>
					<Text textTransform={"capitalize"}>
						{center?.role ? i18n.t(center.role) : "--"}
					</Text>
				</Flex>
				<Flex
					my="12px"
					mx="4px"
					py="12px"
					borderBottom="1px"
					borderColor="gray.100"
					justifyContent={"space-between"}
					_hover={{ bg: "zinc.50" }}
				>
					<Text>Accès</Text>
					<Text textTransform={"capitalize"}>
						{center?.access ? i18n.t(center.access) : "--"}
					</Text>
				</Flex>
				<Flex
					my="12px"
					mx="4px"
					py="12px"
					borderBottom="1px"
					borderColor="gray.100"
					justifyContent={"space-between"}
					_hover={{ bg: "zinc.50" }}
				>
					<Text>Email</Text>
					<Text>{user.email}</Text>
				</Flex>
				<Flex
					my="12px"
					mx="4px"
					py="12px"
					borderBottom="1px"
					borderColor="gray.100"
					justifyContent={"space-between"}
					_hover={{ bg: "zinc.50" }}
				>
					<Text>Mot de passe</Text>
					<Text>°°°</Text>
				</Flex>
			</Box>
		</>
	);
}

export default SettingsPagePersonnalInformationPanel;
